export default "/images/other_ad.png?219ba2c012d7cf84538ac223f613ebe8";